import apiClient from './apiClient';

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export interface StoryUser {
  _id: string;
  name?: string;
  username?: string;
  profileImage?: string;
  email?: string;
  phone?: string;
}

export interface Story {
  _id: string;
  user?: StoryUser | string;
  mediaUrl: string;
  mediaType: 'image' | 'video';
  thumbnailUrl?: string;
  caption?: string;
  viewsCount?: number;
  expiresAt?: string;
  createdAt: string;
}

export interface StoriesPagination {
  currentPage: number;
  totalPages: number;
  totalItems?: number;
  itemsPerPage?: number;
}

class StoriesService {
  /** Admin: list ALL stories (including expired). Backend: GET /stories/admin/all. */
  async getAllStories(params: { page?: number; limit?: number } = {}) {
    const response = await apiClient.get<ApiResponse<{ stories: Story[]; pagination: StoriesPagination }>>(
      '/stories/admin/all',
      { params },
    );
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch stories');
    }
    const data: any = response.data.data;
    return {
      stories: (data?.stories ?? []) as Story[],
      pagination: (data?.pagination ?? { currentPage: 1, totalPages: 1 }) as StoriesPagination,
    };
  }

  /** Delete any story (admin-allowed). Backend: DELETE /stories/:storyId. */
  async deleteStory(id: string) {
    const response = await apiClient.delete<ApiResponse<null>>(`/stories/${id}`);
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to delete story');
    }
    return true;
  }
}

const storiesService = new StoriesService();
export default storiesService;
